window.addEventListener('DOMContentLoaded', (event) => {
    const forms = document.querySelectorAll('form');

    forms.forEach((form: HTMLFormElement) => {
        handleAutoSubmit(form);

        form.addEventListener('submit', () => {
            const submitButton = form.querySelector('button[type=submit]');

            if (!submitButton || submitButton.classList.contains('allow-multiple-submissions')) {
              return;
            }

            setTimeout(() => {
                submitButton.setAttribute('disabled', 'true');
            }, 50);
        });
    });
}, {once : true});

function handleAutoSubmit(form: HTMLFormElement): void {
    const autoSubmitSelector = '[data-auto-submit]';
    const autoSubmit: HTMLElement | null = document.querySelector(autoSubmitSelector);

    if (!autoSubmit) {
        return;
    }

    form.submit();
}
